<template>
  <div class="invoices">
    <div class="container">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h1>Invoices</h1>
        <div>
          <div class="input-group">
            <input 
              type="text" 
              class="form-control" 
              placeholder="Search invoices..." 
              v-model="searchQuery"
            >
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
              {{ currentFilter }}
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li><a class="dropdown-item" href="#" @click.prevent="setFilter('All')">All</a></li>
              <li><a class="dropdown-item" href="#" @click.prevent="setFilter('Paid')">Paid</a></li>
              <li><a class="dropdown-item" href="#" @click.prevent="setFilter('Pending')">Pending</a></li>
              <li><a class="dropdown-item" href="#" @click.prevent="setFilter('Overdue')">Overdue</a></li>
            </ul>
          </div>
        </div>
      </div>
      
      <invoice-list
        :invoices="invoices"
        :loading="loading"
        :error="error"
        :filter="currentFilter"
        :search="searchQuery"
        :on-clear-filters="clearFilters"
        :default-sort-column="'date'"
        :default-sort-direction="'desc'"
      />
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import InvoiceList from '@/components/InvoiceList.vue'

export default {
  name: 'InvoicesView',
  components: {
    InvoiceList
  },
  setup() {
    const store = useStore()
    
    // State
    const loading = ref(true)
    const error = ref(null)
    const searchQuery = ref('')
    const currentFilter = ref('All')
    
    // Computed properties
    const invoices = computed(() => store.getters['invoices/allInvoices'])
    
    // Methods
    const setFilter = (filter) => {
      currentFilter.value = filter
    }
    
    const clearFilters = () => {
      searchQuery.value = '';
      currentFilter.value = 'All';
    };
    
    // Fetch data on component mount
    onMounted(async () => {
      try {
        loading.value = true
        await store.dispatch('invoices/fetchInvoices')
      } catch (err) {
        error.value = 'Failed to load invoices. Please try again.'
        console.error(err)
      } finally {
        loading.value = false
      }
    })
    
    return {
      loading,
      error,
      invoices,
      searchQuery,
      currentFilter,
      setFilter,
      clearFilters
    }
  }
}
</script>

<style scoped>
.invoices {
  padding: 20px 0;
}
</style>